import type LxcError from "~/core/models/LxcError.class";
import RestService from "~/core/services/rest.service";
import businessUnitService from "~/modules/businessUnit/services/businessUnit.service";
import type { LicensePlatformIdCard } from "~/modules/license/models/LicensePlatformIdCard.interface";
import organizationService from "~/modules/organization/services/organization.service";

export class PlatformIdCardService extends RestService {
  private PLATFORM_ID_CARD_PATH = "/platformIdCard";

  async getBusinessUnitPlatformIdCard(
    businessUnitCode: number,
  ): Promise<LicensePlatformIdCard | LxcError> {
    return this.$apiV2.get(
      `${businessUnitService.getBusinessUnitPath(businessUnitCode)}${this.PLATFORM_ID_CARD_PATH}`,
    );
  }

  async getOrganizationPlatformIdCard(
    organizationCode?: number,
  ): Promise<LicensePlatformIdCard | LxcError> {
    return this.$apiV2.get(
      `${organizationService.getOrganizationPath(organizationCode)}${this.PLATFORM_ID_CARD_PATH}`,
    );
  }
}
export default new PlatformIdCardService();
